import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  if (user === null) {
    // Still resolving
    return (
      <div
        data-testid="auth-loading"
        className="min-h-screen bg-black text-silver-100 flex items-center justify-center"
      >
        <div className="flex items-center gap-3 font-mono text-[10px] tracking-[0.42em]">
          <span className="w-2 h-2 rounded-full bg-silver-100 animate-pulse" />
          VERIFYING · SIGNATURE
        </div>
      </div>
    );
  }

  if (!user) {
    return (
      <Navigate to="/login" state={{ from: location.pathname }} replace />
    );
  }

  return children;
};

export default ProtectedRoute;
